// @flow strict

import * as React from 'react'
import { type PropsWithChildren } from '@mondough/public-web-components'
import styles from './BusinessMarkdownSection.module.scss'
import SubtitleSection from '../SubtitleSection'
import { SectionWrapper, SectionThemes } from '../SectionWrapper'
import { MarkdownContent } from '../MarkdownContent'
import { type MarkdownSectionProps } from '../MarkdownSection'

export default function BusinessMarkdownSection({
  children,
  markdownContent,
  reverse,
}: PropsWithChildren<
  MarkdownSectionProps,
  React.Element<typeof SubtitleSection>,
>) {
  return (
    <SectionWrapper
      theme={SectionThemes.LIGHT}
      className={styles.wrapper}
      contentClassName={styles.content}
    >
      {children}
      <MarkdownContent>{markdownContent}</MarkdownContent>
    </SectionWrapper>
  )
}
